import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/material';

interface ILoader {
  size?: string;
  sx?: SxProps;
  color?: string;
}

const Loader = ({ size, sx, color }: ILoader) => {
  return (
    <Box
      sx={{
        ...sx,
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress
        size={`${size ? size : '3'}rem`}
        style={{ color: color ? color : 'white' }}
      />
    </Box>
  );
};

export default Loader;
